 

import React from 'react';
import { LayoutDashboard, CalendarDays, Settings, Bell, Plus, Sparkles } from 'lucide-react';
import { useAppStore } from '../store/useAppStore';
import PushNotificationBootstrap from './PushNotificationBootstrap';
import PushNotificationFeedBridge from './PushNotificationFeedBridge';
import PushToastStack from './PushToastStack';
import { withNavigation } from './Navigation/NavigationWraper';

const Layout = ({ children }) => {
  const { setIsLoggingOut, setIsCheckingAuth, user } = useAppStore();
  const handleLogout = () => {
    setIsLoggingOut(true);
    setIsCheckingAuth(false);
  };
  const { identity } = user || {};

  const navigation = [
    { name: 'Dashboard', label: 'Home', href: '/dashboard', icon: LayoutDashboard, mobileLabel: 'Home', showInMobileTabs: true },
    { name: 'Brand', label: 'Brand', href: '/brand', icon: Sparkles, mobileLabel: 'Brand', showInMobileTabs: true },
    { name: 'CampaignAgent', label: 'Create', href: '/create', icon: Plus, mobileLabel: 'Agent', showInMobileTabs: true, isAgentAction: true },
    { name: 'Calendar', label: 'Schedule', href: '/schedule', icon: CalendarDays, mobileLabel: 'Schedule', showInMobileTabs: true },
    { name: 'Notifications', label: 'Notifications', href: '/notifications', icon: Bell, mobileLabel: 'Notifications', showInMobileTabs: true },
    { name: 'Settings', label: 'Account settings', href: '/settings', icon: Settings, mobileLabel: 'Account settings', showInMobileTabs: false },
  ];

  return (
    <NavigationWrapper
      navigation={navigation}
      identity={identity}
      onLogout={handleLogout}
      logoSrc='/logo/Logo.png'
    >
      <PushNotificationBootstrap />
      <PushNotificationFeedBridge />
      <PushToastStack />
      {children}
    </NavigationWrapper>
  );
};

const NavigationWrapper = withNavigation(({ children }) => <>{children}</>);

export default Layout;
